import imageLogo from '../../Images/Home/CC_SubmarkLogo_Colour.svg';
import '../../Styles/Sass/WhoWeAre.scss';

function WhoWeAre() {
  return (
    <section className='whoWeAre'>
    	<div className='whoWeAre__textBox'>
    		<h2 className='whoWeAre__title'>WHO WE ARE</h2>
    		<p className='whoWeAre__text'>Who are we? We are you. Like-minded individuals that share a 
			common goal to hire and be hired to clean at the highest level. 
			More importantly, we’re a single-minded brand connecting companies, 
			households, and people, holding each other to the highest of standards in building and home cleaning services.</p>
    		<button className='blueButton whoWeAre__button'>Learn More</button>
    	</div>
    	<img className='whoWeAre__image' src={imageLogo} alt="" />
    </section>
  );
}

export default WhoWeAre;
